import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as nls from '../../../nls.js';
import { KeyChord } from '../../../base/common/keyCodes.js';
import { EditorAction, registerEditorAction } from '../../browser/editorExtensions.js';
import { EditorContextKeys } from '../../common/editorContextKeys.js';
import { BlockCommentCommand } from './blockCommentCommand.js';
import { LineCommentCommand } from './lineCommentCommand.js';
import { MenuId } from '../../../platform/actions/common/actions.js';

var CommentLineAction = /*#__PURE__*/function (_EditorAction) {
  _inherits(CommentLineAction, _EditorAction);

  var _super = _createSuper(CommentLineAction);

  function CommentLineAction(type, opts) {
    var _this;

    _classCallCheck(this, CommentLineAction);

    _this = _super.call(this, opts);
    _this._type = type;
    return _this;
  }

  _createClass(CommentLineAction, [{
    key: "run",
    value: function run(accessor, editor) {
      if (!editor.hasModel()) {
        return;
      }

      var model = editor.getModel();
      var commands = [];
      var selections = editor.getSelections();
      var modelOptions = model.getOptions();
      var commentsOptions = editor.getOption(14
      /* comments */
      );

      var _iterator = _createForOfIteratorHelper(selections),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var selection = _step.value;
          commands.push(new LineCommentCommand(selection, modelOptions.tabSize, this._type, commentsOptions.insertSpace, commentsOptions.ignoreEmptyLines));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      editor.pushUndoStop();
      editor.executeCommands(this.id, commands);
      editor.pushUndoStop();
    }
  }]);

  return CommentLineAction;
}(EditorAction);

var ToggleCommentLineAction = /*#__PURE__*/function (_CommentLineAction) {
  _inherits(ToggleCommentLineAction, _CommentLineAction);

  var _super2 = _createSuper(ToggleCommentLineAction);

  function ToggleCommentLineAction() {
    _classCallCheck(this, ToggleCommentLineAction);

    return _super2.call(this, 0
    /* Toggle */
    , {
      id: 'editor.action.commentLine',
      label: nls.localize('comment.line', "Toggle Line Comment"),
      alias: 'Toggle Line Comment',
      precondition: EditorContextKeys.writable,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: 2048
        /* CtrlCmd */
        | 85
        /* US_SLASH */
        ,
        weight: 100
        /* EditorContrib */

      },
      menuOpts: {
        menuId: MenuId.MenubarEditMenu,
        group: '5_insert',
        title: nls.localize({
          key: 'miToggleLineComment',
          comment: ['&& denotes a mnemonic']
        }, "&&Toggle Line Comment"),
        order: 1
      }
    });
  }

  return ToggleCommentLineAction;
}(CommentLineAction);

var AddLineCommentAction = /*#__PURE__*/function (_CommentLineAction2) {
  _inherits(AddLineCommentAction, _CommentLineAction2);

  var _super3 = _createSuper(AddLineCommentAction);

  function AddLineCommentAction() {
    _classCallCheck(this, AddLineCommentAction);

    return _super3.call(this, 1
    /* ForceAdd */
    , {
      id: 'editor.action.addCommentLine',
      label: nls.localize('comment.line.add', "Add Line Comment"),
      alias: 'Add Line Comment',
      precondition: EditorContextKeys.writable,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: KeyChord(2048
        /* CtrlCmd */
        | 41
        /* KEY_K */
        , 2048
        /* CtrlCmd */
        | 33
        /* KEY_C */
        ),
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return AddLineCommentAction;
}(CommentLineAction);

var RemoveLineCommentAction = /*#__PURE__*/function (_CommentLineAction3) {
  _inherits(RemoveLineCommentAction, _CommentLineAction3);

  var _super4 = _createSuper(RemoveLineCommentAction);

  function RemoveLineCommentAction() {
    _classCallCheck(this, RemoveLineCommentAction);

    return _super4.call(this, 2
    /* ForceRemove */
    , {
      id: 'editor.action.removeCommentLine',
      label: nls.localize('comment.line.remove', "Remove Line Comment"),
      alias: 'Remove Line Comment',
      precondition: EditorContextKeys.writable,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: KeyChord(2048
        /* CtrlCmd */
        | 41
        /* KEY_K */
        , 2048
        /* CtrlCmd */
        | 51
        /* KEY_U */
        ),
        weight: 100
        /* EditorContrib */

      }
    });
  }

  return RemoveLineCommentAction;
}(CommentLineAction);

var BlockCommentAction = /*#__PURE__*/function (_EditorAction2) {
  _inherits(BlockCommentAction, _EditorAction2);

  var _super5 = _createSuper(BlockCommentAction);

  function BlockCommentAction() {
    _classCallCheck(this, BlockCommentAction);

    return _super5.call(this, {
      id: 'editor.action.blockComment',
      label: nls.localize('comment.block', "Toggle Block Comment"),
      alias: 'Toggle Block Comment',
      precondition: EditorContextKeys.writable,
      kbOpts: {
        kbExpr: EditorContextKeys.editorTextFocus,
        primary: 1024
        /* Shift */
        | 512
        /* Alt */
        | 31
        /* KEY_A */
        ,
        linux: {
          primary: 2048
          /* CtrlCmd */
          | 1024
          /* Shift */
          | 31
          /* KEY_A */

        },
        weight: 100
        /* EditorContrib */

      },
      menuOpts: {
        menuId: MenuId.MenubarEditMenu,
        group: '5_insert',
        title: nls.localize({
          key: 'miToggleBlockComment',
          comment: ['&& denotes a mnemonic']
        }, "Toggle &&Block Comment"),
        order: 2
      }
    });
  }

  _createClass(BlockCommentAction, [{
    key: "run",
    value: function run(accessor, editor) {
      if (!editor.hasModel()) {
        return;
      }

      var commentsOptions = editor.getOption(14
      /* comments */
      );
      var commands = [];
      var selections = editor.getSelections();

      var _iterator2 = _createForOfIteratorHelper(selections),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var selection = _step2.value;
          commands.push(new BlockCommentCommand(selection, commentsOptions.insertSpace));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      editor.pushUndoStop();
      editor.executeCommands(this.id, commands);
      editor.pushUndoStop();
    }
  }]);

  return BlockCommentAction;
}(EditorAction);

registerEditorAction(ToggleCommentLineAction);
registerEditorAction(AddLineCommentAction);
registerEditorAction(RemoveLineCommentAction);
registerEditorAction(BlockCommentAction);